var map = {
	"./aff.png": "./openbrix-design-system/images/banner/tab/aff.png",
	"./cb.png": "./openbrix-design-system/images/banner/tab/cb.png",
	"./dashboard.png": "./openbrix-design-system/images/banner/tab/dashboard.png",
	"./document.png": "./openbrix-design-system/images/banner/tab/document.png",
	"./happy.png": "./openbrix-design-system/images/banner/tab/happy.png",
	"./id.png": "./openbrix-design-system/images/banner/tab/id.png",
	"./market.png": "./openbrix-design-system/images/banner/tab/market.png",
	"./openflow.png": "./openbrix-design-system/images/banner/tab/openflow.png",
	"./ref.png": "./openbrix-design-system/images/banner/tab/ref.png",
	"./rewards.png": "./openbrix-design-system/images/banner/tab/rewards.png",
	"./rtr.png": "./openbrix-design-system/images/banner/tab/rtr.png",
	"./ti.png": "./openbrix-design-system/images/banner/tab/ti.png",
	"./tp.png": "./openbrix-design-system/images/banner/tab/tp.png"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./openbrix-design-system/images/banner/tab sync recursive ^\\.\\/.*$";